<template>
    <section>
        <Header />
        <div class="container">
            <main class="principal">
                <picture class="only-pc aos">
                    <source srcset="../assets/landing/background_principal_pc.webp" type="image/webp">
                    <img src="../assets/landing/background_principal_pc.png" alt="Frame decorativo">
                </picture>
                <picture class="only-mov aos">
                    <source srcset="../assets/landing/background_principal_mov.webp" type="image/webp">
                    <img src="../assets/landing/background_principal_mov.png" alt="Frame decorativo">
                </picture>
                <h1 class="aos">Diseño de tiendas en línea</h1>
                <p class="aos">Genera más ventas en el mundo digital. <br class="only-mov">
                    Contamos con el diseño
                    y desarrollo
                    de tiendas en línea ideales para cualquier tipo de empresa, sin importar el giro.</p>
            </main>
            <section class="medio">
                <picture class="only-mov">
                    <source srcset="../assets/landing/background_medio_pc.webp" type="image/webp">
                    <img src="../assets/landing/background_medio_pc.png" alt="Imagen decorativa">
                </picture>
                <div class="aos">
                    <h2 class="medio__titulo">¿Qué genera el vender en línea?</h2> <br><br>
                    <p>Presencia: te harás notar y demostrarás todos los beneficios que ofrece tu servicio/producto.</p>
                    <br class="only-pc">
                    <p>Ventas: Facilitarás el proceso de compra de tus clientes e incrementarás los resultados.</p><br
                        class="only-pc">
                    <p>Fidelidad: Conquistarás su lealtad y construirás una relación duradera con tus clientes.</p> <br
                        class="only-pc">
                    <p>Alcance: No habrá limitaciones. Llegarás a más personas sin importar el lugar en el que estas se
                        encuentren.</p> <br><br><br><br>
                </div>
                <div class="aos">
                    <p>
                        La inversión no es una excusa, comienza las ventas en línea con tu sitio a 3 meses sin
                        intereses.Y
                        llévate gratis una campaña de Google Ads, la cuál te ayudará a posicionarte mejor e incrementar
                        tu
                        venta digital.
                    </p> <br>

                    <p>
                        ¿Qué es lo mejor de esto? Que puedes estar vendiendo las 24 horas del día, 7 días a la semana,
                        todos
                        los días del año sin necesidad de tener obligatoriamente presencia física.
                    </p> <br>

                    <p>
                        El como vender en línea es una pregunta que se pueden generar desde emprendedores hasta
                        empresarios;
                        por eso en Legrafica contamos con una asesoría ideal para cada uno:
                    </p> <br>
                </div>

                <div>
                    <div class="aos">
                        <a href="https://wa.link/59h09i">
                            <picture>
                                <source srcset="../assets/landing/medio_1.webp" type="image/webp">
                                <img src="../assets/landing/medio_1.png" alt="Imagen decorativa">
                            </picture>
                            <p>Emprendedores</p>
                        </a>
                    </div>
                    <div class="aos">
                        <a href="https://wa.link/njfgd3">
                            <picture>
                                <source srcset="../assets/landing/medio_2.webp" type="image/webp">
                                <img src="../assets/landing/medio_2.png" alt="Imagen decorativa">
                            </picture>
                            <p>Empresarios</p>
                        </a>
                    </div>
                </div>
            </section>
            <section class="proyectos">
                <h2 class="aos">Conoce algunos de <span>nuestros proyectos:</span></h2>
                <div class="proyectos__galeria">
                    <button class="aos" v-for="(project, index) in projects" :key="index"
                        @click="navAndDialog(project.link, project.imageWebp)" :aria-label="project.title">
                        <picture>
                            <source :srcset="project.imageWebp" type="image/webp">
                            <img :src="project.imagePng" :alt="project.title">
                        </picture>
                    </button>
                </div>
                <h2 class="aos">Trabajemos juntos, <span>cotiza aquí.</span></h2>

                <form class="aos" @submit.prevent="contactoLanding()">
                    <label for="form__name">Nombre</label>
                    <input type="text" id="form__name" v-model="name">
                    <label for="form__email">Correo electrónico</label>
                    <input type="email" id="form__email" v-model="email">
                    <label for="form__phone">Teléfono</label>
                    <input type="number" v-model="phone">
                    <label for="form__message">Mensaje</label>
                    <textarea id="form__message" v-model="message"></textarea>

                    <button type="submit">
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="only-pc">
                            <circle cx="24" cy="24" r="24" fill="#987EF3" />
                            <g clip-path="url(#clip0_137_399)">
                                <path
                                    d="M20.592 26.4954C20.4027 26.3414 20.2186 26.1848 20.0274 26.0399C18.3003 24.7329 16.5649 23.4382 14.8538 22.1116C14.6418 21.9478 14.5554 21.6188 14.4107 21.3669C14.6582 21.2636 14.9005 21.089 15.1558 21.0686C20.9931 20.5774 26.8324 20.0967 32.6719 19.6388C33.038 19.6102 33.4206 19.7784 33.796 19.855C33.6243 20.1794 33.5068 20.5536 33.273 20.8224C29.425 25.2399 25.5633 29.6462 21.6938 34.0434C21.5236 34.2358 21.2403 34.326 21.0093 34.4653C20.893 34.1991 20.6807 33.932 20.6759 33.6653C20.6347 31.5008 20.6337 29.3357 20.6171 27.1718C20.6153 26.9529 20.6011 26.7353 20.592 26.4954ZM31.0489 20.8108C31.0355 20.7584 31.0215 20.7081 31.0081 20.6558C26.0791 21.0602 21.1508 21.4659 16.2226 21.8716C17.6536 23.1375 19.115 24.2191 20.5455 25.3392C21.003 25.6977 21.3627 25.7561 21.8979 25.4782C24.7606 23.9967 27.6458 22.5629 30.523 21.1102C30.7038 21.0191 30.874 20.9103 31.0489 20.8108ZM31.4886 21.526C31.3506 21.4643 31.3252 21.4427 31.3123 21.4492C28.1515 23.03 24.99 24.6096 21.8352 26.2055C21.6905 26.2783 21.5217 26.4831 21.521 26.6295C21.5103 28.6332 21.5269 30.6395 21.5376 32.8818C24.9426 28.9959 28.1967 25.2828 31.4886 21.526Z"
                                    fill="white" />
                            </g>
                            <defs>
                                <clipPath id="clip0_137_399">
                                    <rect width="18" height="14.6667" fill="white"
                                        transform="translate(14.4043 21.3701) rotate(-26.7378)" />
                                </clipPath>
                            </defs>
                        </svg>

                        <p>
                            Enviar mensaje
                        </p>
                    </button>

                    <p class="form__status">{{ statusForm }}</p>
                </form>
                <dialog @click="closeModal()">
                    <img :src="imageSelected" alt="Imagen en galería">
                </dialog>
            </section>
        </div>
        <Footer />
    </section>
</template>
<script>
import Header from '../components/on-site/Header.vue';
import Footer from '../components/on-site/Footer.vue';
export default {
    components: {
        Header,
        Footer,
    },

    data() {
        return {
            name: '',
            email: '',
            phone: '',
            message: '',
            statusForm: '',
            imageSelected: null,
            projects: [
                {
                    imageWebp: require('../assets/landing/proyecto_1.webp'),
                    imagePng: require('../assets/landing/proyecto_1.png'),
                    link: '/portafolio-post/barrio-alegre',
                    title: "Barrio Alegre"
                },
                {
                    imageWebp: require('../assets/landing/proyecto_2.webp'),
                    imagePng: require('../assets/landing/proyecto_2.png'),
                    link: '/portafolio-post/por-kilo',
                    title: "Por Kilo"
                },
                {
                    imageWebp: require('../assets/landing/proyecto_3.webp'),
                    imagePng: require('../assets/landing/proyecto_3.png'),
                    link: '/portafolio-post/cimarrones-de-Sonora',
                    title: "Cimarrones FC"
                },
                {
                    imageWebp: require('../assets/landing/proyecto_4.webp'),
                    imagePng: require('../assets/landing/proyecto_4.png'),
                    link: false,
                    title: "Cincelar"
                },
                {
                    imageWebp: require('../assets/landing/proyecto_5.webp'),
                    imagePng: require('../assets/landing/proyecto_5.png'),
                    link: '/portafolio-post/holy-o',
                    title: "Holy O"
                },
                {
                    imageWebp: require('../assets/landing/proyecto_6.webp'),
                    imagePng: require('../assets/landing/proyecto_6.png'),
                    link: false,
                    title: "Mappy"
                },
            ],
        }
    },

    metaInfo: {
        title: 'Diseño de tiendas en línea',  
        meta: [
            {
                name: 'description',
                content: 'Somos expertos en el diseño y desarrollo de tiendas en línea ideales para cualquier tipo de empresa, sin importar el giro. '
            }
        ]
    },

    mounted() {
        let animateOnScroll = () => {
            const allAos = document.querySelectorAll(".aos");

            let allHaveVisibleClass = true;

            allAos.forEach((elemento, index) => {
                let { top, height, bottom } = elemento.getBoundingClientRect();

                if (window.getComputedStyle(elemento).display === 'none'
                    || bottom > 0 && bottom < window.innerHeight
                    || height >= window.innerHeight && top <= 0) {
                    elemento.classList.add("visible");
                }

                if (!elemento.classList.contains("visible")) {
                    allHaveVisibleClass = false;
                }

            });

            if (allHaveVisibleClass) window.removeEventListener('scroll', animateOnScroll)

        }

        window.addEventListener('scroll', animateOnScroll);
        animateOnScroll()
    },

    methods: {
        async contactoLanding() {

            if (this.name === '' || this.name === null || this.name === undefined) {
                this.statusForm = "Campo Nombre no válido";
                return ''
            }

            if (this.email === '' || this.email === null || this.email === undefined) {
                this.statusForm = "Campo Correo Electrónico no válido";
                return ''
            }

            if (this.phone === '' || this.phone === null || this.phone === undefined) {
                this.statusForm = "Campo Teléfono no válido";
                return ''
            }

            if (this.message === '' || this.message === null || this.message === undefined) {
                this.statusForm = "Campo Mensaje no válido";
                return ''
            }

            let data = {
                name: this.name,
                phone: this.phone,
                email: this.email,
                mensaje: this.message,
                from: "landing tiendas en línea ",
            };

            let response = await this.$store.dispatch(
                "admin/enviarMailContacto",
                data
            );

            if (response.status === 'success') {
                this.limpieza();
            } else {
                this.statusForm = "Lo sentimos ha ocurrido un error al intentar entregar tu mensaje.";
            }
        },

        limpieza() {
            this.name = '';
            this.phone = '';
            this.email = '';
            this.message = '';

            this.statusForm = 'Mensaje enviado con éxito';

            setTimeout(() => {
                this.statusForm = '';
            }, 3000);
        },

        navAndDialog(link, image) {
            if (link) {
                window.location.href = link;
            } else {
                this.imageSelected = image;
                this.openModal();
            }
        },

        openModal() {
            const modal = document.querySelector("dialog");
            modal.showModal();
        },

        closeModal() {
            const modal = document.querySelector("dialog");
            this.imageSelected = null;
            modal.close();
        }
    }
}
</script>
<style scoped>
*,
*::after,
*::before {
    box-sizing: border-box;
}

h2,
p {
    margin: 0;
}

section {
    overflow: clip;
}

picture {
    display: block;
}

picture img {
    width: inherit;
    height: inherit;
}

.principal {
    position: relative;
}

.principal picture {
    position: absolute;
    top: 0;
}

.principal h1 {
    font-family: Gramatika-Medium;
    font-style: normal;
    font-weight: 500;
    color: #EF67C2;
    margin: 0;
}

.principal p {
    font-family: "IBM Plex Mono";
    font-weight: 400;
    font-style: normal;
    color: #000;
}

.medio p {
    font-family: "IBM Plex Mono";
    font-weight: 400;
    font-style: normal;
    color: #000;
}

.medio .medio__titulo {
    font-family: "IBM Plex Mono";
    font-weight: 700;
    font-style: normal;
    color: #000;
}


.medio>div:not(:last-of-type) {
    position: relative;
}

.medio>div:not(:last-of-type)::before {
    content: "";
    position: absolute;
    background-color: #FFB6EA;
}

.medio>div:last-of-type {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
}

.medio>div:last-of-type>div {
    display: grid;
    align-content: space-between;
}

.medio>div:last-of-type p {
    color: #987EF3;
    font-family: Gramatika-Medium;
    font-weight: 500;
    font-style: normal;
    text-decoration: underline;
}

.proyectos>h2:first-of-type {
    font-family: Gramatika-Medium;
    font-style: normal;
    font-weight: 500;
    color: #987EF3;
}

.proyectos>h2:first-of-type span {
    color: #FFB6EA;
}

.proyectos>h2:last-of-type {
    font-family: Gramatika-Medium;
    font-style: normal;
    font-weight: 500;
    color: #EF67C2;
}

.proyectos__galeria {
    display: grid;
}

.proyectos__galeria button picture {
    width: inherit;
    height: inherit;
}

.proyectos>h2:last-of-type span {
    color: #B2ACFC;
}

form {
    display: grid;
}

label,
input,
textarea {
    color: #000;
    font-family: "IBM Plex Mono";
    font-style: normal;
    font-weight: 500;
}

input {
    border: 0;
    padding: 0;
}

textarea {
    border: 0;
    resize: none;
    padding: 0;
}

button[type='submit'] {
    border: 0;
    display: grid;
    align-items: center;
    padding: 0;
}


button[type='submit'] p {
    font-family: Gramatika-Bold !important;
    font-style: normal !important;
    font-weight: 400 !important;
    cursor: pointer;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}

.proyectos__galeria button {
    background-color: transparent;
    border: 0;
    padding: 0;
    cursor: pointer;
}

dialog {
    padding: 0;
    border: 0;
    display: flex;
}

dialog::backdrop {
    background-color: rgba(0, 0, 0, 0.5);
}

@media (width < 768px),
(max-width: 767px) {

    .aos {
        opacity: 0;
        transform: translate(0, var(--traslado, -16.908212560386474VW));
        transition: opacity var(--visible, 0.6s) ease-out, transform var(--visible, 0.6s) ease-out;
    }

    .visible {
        opacity: 1;
        transform: translate(0, 0) !important;
    }

    .only-pc {
        display: none;
    }

    .principal {
        background-color: #E4E4F9;
        padding: 41.78743961352657VW 10.869565217391305VW 4.1062801932367154VW 12.80193236714976VW;
    }

    .principal picture {
        --traslado: 0;
        width: 100%;
        left: 0;
        --traslado: 0;
        transform: translate(100%, var(--traslado));
    }

    .principal h1 {
        font-size: 12.077294685990339VW;
        line-height: 109.3%;
        margin-right: 17.985507246376812VW;
    }

    .principal p {
        margin: 17.874396135265698VW 0 0;
        font-size: 2.657004830917874VW;
        line-height: 180%;
    }

    .medio {
        padding: 144.44444444444443VW 10.144927536231885VW 8.695652173913043VW 14.492753623188406VW;
        position: relative;
        background: linear-gradient(to bottom, #E4E4F9 0, #FFFFFF 72.94685990338165VW);
    }

    .medio>picture {
        width: 100%;
        position: absolute;
        top: 5.555555555555555VW;
        left: 0;
    }

    .medio>div:not(:last-of-type)::before {
        height: 0.4830917874396135VW;
        width: 10.869565217391305VW;
    }

    .medio>div:first-of-type::before {
        top: -9.420289855072465VW;
        left: 0;
    }

    .medio>div:nth-of-type(2)::before {
        top: -10.869565217391305VW;
        left: 0;
    }

    .medio p:not(.medio__titulo) {
        font-size: 2.657004830917874VW;
        line-height: 180%;
    }

    .medio__titulo {
        font-size: 3.3816425120772946VW;
        line-height: 180%;
    }

    .medio>div:last-of-type {
        column-gap: 23.42995169082126VW;
        margin-top: 9.903381642512077VW;
    }

    .medio>div:last-of-type>div {
        height: 35.02415458937198VW;
    }

    .medio>div:last-of-type picture {
        width: 27.053140096618357VW;
        height: 27.053140096618357VW;
    }

    .medio>div:last-of-type p {
        font-size: 3.3816425120772946VW;
        line-height: 161.8%;
        text-align: center;
    }

    .medio>div:last-of-type a {
        display: grid;
        height: 35.02415458937198VW;
    }

    .proyectos>h2:first-of-type {
        margin: 8.695652173913043VW 21.73913043478261VW 9.178743961352657VW 10.869565217391305VW;
        font-size: 10.869565217391305VW;
        line-height: 110.8%;
    }

    .proyectos__galeria {
        overflow: clip;
    }

    .proyectos__galeria button:nth-of-type(1) {
        margin: 7.971014492753622VW 0 0 14.492753623188406VW;
        width: 53.864734299516904VW;
        height: 63.28502415458937VW;
        grid-row: 6 / 7;
        --traslado: 0;
        transform: translate(-100%, var(--traslado));

    }

    .proyectos__galeria>button:nth-of-type(2) {
        margin: 0 0 0 14.492753623188406VW;
        width: 71.73913043478261VW;
        height: 79.22705314009661VW;
        grid-row: 1 / 2;
        --traslado: 0;
        transform: translate(100%, var(--traslado));
    }

    .proyectos__galeria>button:nth-of-type(3) {
        margin: 7.246376811594203VW 0 0 20.77294685990338VW;
        width: 58.454106280193244VW;
        height: 75.84541062801932VW;
        grid-row: 3 / 4;
        --traslado: 0;
        transform: translate(-100%, var(--traslado));
    }

    .proyectos__galeria>button:nth-of-type(4) {
        margin: 6.521739130434782VW 0 0 14.492753623188406VW;
        width: 95.89371980676329VW;
        height: 92.7536231884058VW;
        --traslado: 0;
        transform: translate(100%, var(--traslado));

    }

    .proyectos__galeria>button:nth-of-type(5) {
        margin: 7.246376811594203VW 0 0 10.628019323671497VW;
        width: 78.98550724637681VW;
        height: 64.4927536231884VW;
        grid-row: 4 / 5;
        --traslado: 0;
        transform: translate(100%, var(--traslado));
    }

    .proyectos__galeria>button:nth-of-type(6) {
        margin: 5.314009661835748VW 10.38647342995169VW 0 auto;
        width: 59.90338164251207VW;
        height: 73.67149758454107VW;
        grid-row: 2 / 3;
        --traslado: 0;
        transform: translate(-100%, var(--traslado));

    }

    .proyectos>h2:last-of-type {
        margin: 23.42995169082126VW 21.497584541062803VW 0 10.869565217391305VW;
        font-size: 10.869565217391305VW;
        line-height: 110.8%;
    }

    label,
    input,
    textarea {
        font-size: 2.898550724637681VW;
        line-height: 246.8%;
    }


    input {
        border-bottom: 0.24154589371980675VW solid #000;
        margin-bottom: 12.077294685990339VW;
        height: 7.246376811594203VW;
    }

    textarea {
        border-bottom: 0.24154589371980675VW solid #000;
        height: 14.492753623188406VW;
    }

    button[type='submit'] {
        background-color: #3702FB;
        width: 27.053140096618357VW;
        height: 27.053140096618357VW;
        grid-template-columns: auto;
        margin: 17.632850241545896VW auto 0;
        border-radius: 100%;
        padding: 0 3.6231884057971016VW;
    }

    button[type='submit'] p {
        color: #FFFFFF !important;
        font-size: 3.140096618357488VW !important;
        line-height: 106.8% !important;
    }

    form {
        margin: 16.908212560386474VW 9.66183574879227VW 36.95652173913043VW;
    }

    .form__status {
        margin: 4.830917874396135VW 0 0;
        height: 4.830917874396135VW;
        text-align: center;
    }

    dialog {
        background-color: transparent;
        justify-content: center;
    }

    dialog img {
        width: 100%;
        height: auto;
    }
}

@media(width >=768px), (min-width: 768px) {

    .aos {
        opacity: 0;
        transform: translate(0, -5.208333333333334VW);
        transition: opacity var(--visible, 0.6s) ease-out, transform var(--visible, 0.6s) ease-out;
    }

    .visible {
        opacity: 1;
        transform: translate(0, 0);
    }

    .only-mov {
        display: none;
    }

    .principal {
        padding: 15.625VW 54.979167VW 24.479166666666664VW 8.59375VW;
        background: linear-gradient(to bottom, #E4E4F9 54.166666666666664VW, #FFFFFF);
    }

    .principal picture {
        position: absolute;
        width: 52.604166666666664VW;
        height: 52.604166666666664VW;
        right: 2.9166666666666665VW;
    }

    .principal h1 {
        font-size: 7.552083333333333VW;
        line-height: 126%;
    }

    .principal p {
        margin: 3.0729166666666665VW 0 0;
        font-size: 0.8333333333333334VW;
        line-height: 180%;
    }

    .medio {
        padding: 7.5VW 11.458333333333332VW 4.739583333333333VW 51.87500000000001VW;
        background-size: 44.479166666666664VW 48.333333333333336VW;
        background-position: left top;
        background-repeat: no-repeat;
        background-color: #FFF;
        background-image: url("../assets/landing/background_medio_pc.png");
        background-image: url("../assets/landing/background_medio_pc.webp");
    }

    .medio>div:not(:last-of-type)::before {
        height: 0.10416666666666667VW;
        width: 3.125VW;
    }

    .medio>div:first-of-type::before {
        top: -1.7187500000000002VW;
        left: -4.84375VW;
    }

    .medio>div:nth-of-type(2)::before {
        top: -1.9791666666666665VW;
        left: -5.104166666666667VW;
    }

    .medio p:not(.medio__titulo) {
        font-size: 0.78125VW;
        line-height: 180%;
    }

    .medio__titulo {
        font-size: 1.0416666666666665VW;
        line-height: 180%;
    }

    .medio>div:last-of-type {
        column-gap: 5.442708333333333VW;
        margin-top: 1.875VW;
    }

    .medio>div:last-of-type>div {
        height: 10.833333333333334VW;
    }

    .medio>div:last-of-type picture {
        width: 8.6171875VW;
    }

    .medio>div:last-of-type p {
        font-size: 0.8333333333333334VW;
        line-height: 162%;
        text-align: center;
    }

    .proyectos>h2:first-of-type {
        width: 26.041666666666668VW;
        margin: 4.739583333333333VW 0 6.666666666666667VW 9.635416666666668VW;

        font-size: 5.208333333333334VW;
        line-height: 104.3%;
    }

    .proyectos__galeria {
        grid-template-columns: repeat(3, auto);
        justify-content: center;
    }

    .proyectos__galeria button {
        overflow: clip;
    }

    .proyectos__galeria button picture {
        transition: 0.6s ease-out;
    }

    .proyectos__galeria button:hover picture {
        transform: scale(1.2);
    }

    .proyectos__galeria button:nth-of-type(1) {
        margin: 1.7708333333333333VW 0 0 0;
        width: 19.947916666666668VW;
        height: 23.333333333333332VW;
    }

    .proyectos__galeria>button:nth-of-type(2) {
        margin: 0 0 0 2.1875VW;
        width: 30.572916666666668VW;
        height: 33.697916666666664VW;
    }

    .proyectos__galeria>button:nth-of-type(3) {
        margin: 2.2395833333333335VW 0 0 1.875VW;
        width: 20.729166666666668VW;
        height: 26.875VW;
    }

    .proyectos__galeria>button:nth-of-type(4) {
        margin: -6.09375VW 0 0 -2.864583333333333VW;
        width: 21.71875VW;
        height: 20.989583333333332VW;
    }

    .proyectos__galeria>button:nth-of-type(5) {
        margin: 3.5937499999999996VW 0 0 3.0729166666666665VW;
        width: 27.239583333333332VW;
        height: 22.239583333333332VW;
    }

    .proyectos__galeria>button:nth-of-type(6) {
        margin: -2.4479166666666665VW 0 0 2.96875VW;
        width: 19.6875VW;
        height: 24.21875VW;
    }

    .proyectos>h2:last-of-type {
        width: 50VW;
        margin: 9.583333333333334VW 0 6.135416666666666VW 9.583333333333334VW;

        font-size: 5.208333333333334VW;
        line-height: 104.3%;
    }

    form {
        width: 50VW;
        --traslado: 100%, 0;
        margin: 0 0 12.135416666666666VW 9.583333333333334VW;
    }

    label,
    input,
    textarea {
        font-size: 0.7291666666666666VW;
        line-height: 246.8%;
    }


    input {
        border-bottom: 0.052083333333333336VW solid #000;
        margin-bottom: 2.864583333333333VW;
        height: 1.8229166666666667VW;
    }

    textarea {
        border-bottom: 0.052083333333333336VW solid #000;
        height: 4.166666666666666VW;
    }

    button[type='submit'] {
        background-color: transparent;
        color: #000;
        width: 9.835416666666668VW;
        grid-template-columns: auto 1fr;
        column-gap: 1.0416666666666665VW;
        margin: 3.4375000000000004VW 0 0;
    }

    button[type='submit'] p {
        font-size: 0.8333333333333334VW !important;
        line-height: 152.3% !important;
    }

    .form__status {
        margin: 1.0416666666666665VW 0 0;
        height: 1.5625VW;
    }
}
</style>